import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routes } from "engine/routes";
import { useAppSelector } from "engine/store";
import { canAccessTags, canAccessUsers, canAccessOrganisations } from "helpers/permissions";
import { StyledMenu } from "./styled";

export const Menu = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const user = useAppSelector((state) => state.auth.user);

  const menuItems = [
    {
      key: "articles",
      label: <Link to={routes.dashboard.articles().overview}>{t("dashboard.articles")}</Link>,
    },
  ];

  // Only show Tags menu for admin users
  if (canAccessTags(user)) {
    menuItems.push({
      key: "tags",
      label: <Link to={routes.dashboard.tags().overview}>{t("dashboard.tags")}</Link>,
    });
  }

  // Only show Users menu for admin users
  if (canAccessUsers(user)) {
    menuItems.push({
      key: "users",
      label: <Link to={routes.dashboard.users().overview}>{t("dashboard.users")}</Link>,
    });
  }

  // Only show Organisations menu for admin users
  if (canAccessOrganisations(user)) {
    menuItems.push({
      key: "organisations",
      label: <Link to={routes.dashboard.organisations().overview}>{t("dashboard.organisations")}</Link>,
    });
  }

  return <StyledMenu mode="horizontal" selectedKeys={[pathname.split("/")[2]]} items={menuItems} />;
};
